import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toSuggestionDomain } from './transformers/toSuggestionDomain';

// Fetches all suggestions for a tenant and maps them onto the `Data.Suggestion` domain.
async function getSuggestions(args: { tenantId: string }) {
  const { tenantId } = args;

  const apiCall = apiClient.Suggestion_GetSuggestions({
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load suggestions',
    },
    onSuccess: (dtos) => {
      const { suggestionDomain } = toSuggestionDomain({ dtos: dtos ?? [] });
      return { suggestionDomain };
    },
  });
}

export { getSuggestions };
